import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Método de pago',
    [BillingMode.InternalInvoicing]: 'Pagos',
  },
};
